/* libs/iot-platform/iot-platform-ui-favorite-view/src/lib/components/favorite-view-forms/favorite-view-form/favorite-view-form.component.scss */
::ng-deep .mat-horizontal-stepper-wrapper,
::ng-deep .mat-horizontal-content-container,
::ng-deep .mat-horizontal-stepper-content-current {
  height: 100% !important;
}
/*# sourceMappingURL=favorite-view-form.component.css.map */
